var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1103 15.864L0.48075 8.75947C0.270373 8.47458 0.119973 8.15133 0.0383531 7.80865C-0.043267 7.46597 -0.0544668 7.11074 0.00540916 6.76375C0.0652852 6.41676 0.195034 6.08499 0.38706 5.78786C0.579087 5.49073 0.829533 5.23421 1.12374 5.03331C1.41794 4.83241 1.75 4.69117 2.10046 4.61786C2.45092 4.54455 2.81275 4.54064 3.16478 4.60636C3.5168 4.67208 3.85193 4.80611 4.15057 5.0006C4.4492 5.1951 4.70533 5.44615 4.90397 5.73906L8.53011 10.3164L16.1255 1.13317C16.3243 0.843444 16.5799 0.595475 16.8772 0.403713C17.1746 0.211951 17.5078 0.0802318 17.8575 0.0162316C18.2072 -0.0477686 18.5664 -0.04277 18.9141 0.0309358C19.2618 0.104642 19.5911 0.245581 19.8828 0.44554C20.1745 0.645499 20.4228 0.90048 20.6131 1.19562C20.8035 1.49077 20.9322 1.82017 20.9916 2.16464C21.0511 2.5091 21.0401 2.86175 20.9594 3.20201C20.8787 3.54228 20.7298 3.86337 20.5215 4.14657L10.8418 15.853C10.5919 16.2088 10.2564 16.4984 9.86513 16.696C9.47384 16.8937 9.03887 16.9933 8.59892 16.9861C8.1199 17.0342 7.63649 16.9555 7.19888 16.7582C6.76127 16.5609 6.3854 16.2522 6.1103 15.864Z",
    fill: "#A6FF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOk);
export default __webpack_public_path__ + "static/media/icon-ok.2d480379be9a086508fab652e72cfa65.svg";
export { ForwardRef as ReactComponent };